import { Component, OnInit } from '@angular/core';

// Custom imports
import { AuthService } from '../auth.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  public resetToken: String;
  public subscription: Subscription;
  //public errorMessage: String;
  //public successMessage: String;
  public resetData = {
          password: '',
          verifyPassword: ''
        };

  constructor(private _authservice: AuthService, private _route: ActivatedRoute, private _notifyService: NotificationService) { }

  ngOnInit() {
    /*this.clearMessages();
    this.errorMessage = '';
    this.successMessage = '';*/
    this.subscription = this._route
    .queryParams
    .subscribe(
      params => this.resetToken = params ['token']
    );    
  }

  reset(){
    //this.clearMessages();
    if(this.resetData.verifyPassword != this.resetData.password){
      this._notifyService.showError("Mot de passe de vérification incorrect", "Reset password", 3000)
      
      //this.errorMessage = 'Mot de passe de vérification incorrect';
    }else if(this.resetToken ==  undefined){
      this._notifyService.showError("Token inexistant ", "Reset password", 3000)
      //this.errorMessage = 'Token inexistant ';
    }else if(this.resetData.verifyPassword == "" || this.resetData.password == ""){
      this._notifyService.showError("Les champs sont obligatoires ", "Reset password", 3000)
      //this.errorMessage = 'Token inexistant ';
    }
    else{
      this._authservice.resetPassword(this.resetData, this.resetToken);
      this._notifyService.showSuccess("Ton mot de passe a été changé ", "Reset password", 5000)
      //this.successMessage = "Ton mot de passe a été changé"

    }
  }
  
  /*clearMessages(){
    this.errorMessage = '';
    this.successMessage = '';
  }


  resetSuccesMessage(){
    setTimeout(()=>{
      this.successMessage = '';
    }, 5000);
  }

  resetErrorMessage(){
    setTimeout(()=>{
      this.errorMessage = '';
    }, 3000);
  }
*/


}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts